module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/1/1-6f1f8b01fafafac32bb777ab0a9259ee.jpg";